import type { TranslationKey } from '@/lib/i18n';

export const CHECKOUT_ABANDONED_TITLE = [
  'common:checkoutAbandoned.title',
  'You left items in your cart',
] as const satisfies TranslationKey;

export const CHECKOUT_ABANDONED_DESCRIPTION = [
  'common:checkoutAbandoned.description',
  'Your cart is still saved. Complete your checkout now before your items sell out!',
] as const satisfies TranslationKey;

export const CHECKOUT_ABANDONED_CTA_CONTINUE = [
  'common:checkoutAbandoned.continueCheckout',
  'Continue Checkout',
] as const satisfies TranslationKey;

export const CHECKOUT_ABANDONED_CTA_LATER = [
  'common:checkoutAbandoned.maybeLater',
  'Maybe Later',
] as const satisfies TranslationKey;
